// extracted by mini-css-extract-plugin
export default {"top":"style_top__WGUhs","profile":"style_profile__U9fQ+","image":"style_image__2O34y","name":"style_name__gJZ44","Shouts":"style_Shouts__kMAve","options":"style_options__5PJTa"};